import { MSG_TYPE_MODAL_DIALOG_CLOSE as ACTUAL_MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
if (ACTUAL_MSG_TYPE_MODAL_DIALOG_CLOSE !== 'MODAL_DIALOG_CLOSE') {
  throw new Error('collaboration-sidebar/constants/IFrameMessageTypes: MSG_TYPE_MODAL_DIALOG_CLOSE has changed value');
}
export const MSG_TYPE_MODAL_DIALOG_CLOSE = ACTUAL_MSG_TYPE_MODAL_DIALOG_CLOSE;

// Common
export const MSG_NAVIGATE_TO_URL = 'MSG_NAVIGATE_TO_URL';
export const MSG_WINDOW_CLICKED = 'MSG_WINDOW_CLICKED';

// Comment
export const MSG_TYPE_CONFIRM_DELETE_COMMENT = 'MSG_TYPE_CONFIRM_DELETE_COMMENT';
export const MSG_TYPE_DELETE_COMMENT = 'MSG_TYPE_DELETE_COMMENT';
export const MSG_TYPE_DELETE_COMMENT_IN_CACHE = 'MSG_TYPE_DELETE_COMMENT_IN_CACHE';
export const MSG_TYPE_DELETE_COMMENT_SUCCESS = 'MSG_TYPE_DELETE_COMMENT_SUCCESS';
export const MSG_TYPE_DELETE_COMMENT_FAILURE = 'MSG_TYPE_DELETE_COMMENT_FAILURE';
export const MSG_TYPE_CREATE_COMMENT_FAILURE = 'MSG_TYPE_CREATE_COMMENT_FAILURE';
export const MSG_TYPE_CREATE_COMMENT_IN_CACHE = 'MSG_TYPE_CREATE_COMMENT_IN_CACHE';
export const MSG_TYPE_UPDATE_COMMENT_IN_CACHE = 'MSG_TYPE_UPDATE_COMMENT_IN_CACHE';
export const MSG_TYPE_UPDATE_COMMENT_FAILURE = 'MSG_TYPE_UPDATE_COMMENT_FAILURE';
export const MSG_TYPE_FETCH_COMMENTS_FAILURE = 'MSG_TYPE_FETCH_COMMENTS_FAILURE';
export const MSG_TYPE_FETCH_TEAMS_FAILURE = 'MSG_TYPE_FETCH_TEAMS_FAILURE';
export const MSG_TYPE_FETCH_CALENDAR_TYPES_FAILURE = 'MSG_TYPE_FETCH_CALENDAR_TYPES_FAILURE';
export const MSG_TYPE_FETCH_CAMPAIGNS_FAILURE = 'MSG_TYPE_FETCH_CAMPAIGNS_FAILURE';
export const MSG_TYPE_FETCH_CALENDAR_EVENTS_FAILURE = 'MSG_TYPE_FETCH_CALENDAR_EVENTS_FAILURE';
export const MSG_TYPE_OPENED_MINI_COMMENTER = 'MSG_TYPE_OPENED_MINI_COMMENTER';
export const MSG_TYPE_RESIZE_MINI_COMMENTER = 'MSG_TYPE_RESIZE_MINI_COMMENTER';
export const MSG_TYPE_MINI_COMMENTER_LOADED_COMMENTS = 'MSG_TYPE_MINI_COMMENTER_LOADED_COMMENTS';
export const MSG_TYPE_SET_MINI_COMMENTER_MIN_HEIGHT_FOR_POPOVER = 'MSG_TYPE_SET_MINI_COMMENTER_MIN_HEIGHT_FOR_POPOVER';
export const MSG_TYPE_RESIZED_MINI_COMMENTER = 'MSG_TYPE_RESIZED_MINI_COMMENTER';
export const MSG_TYPE_CLOSE_MINI_COMMENTER = 'MSG_TYPE_CLOSE_MINI_COMMENTER';
export const MSG_TYPE_REMOVE_EMBEDDED_COMMENT = 'MSG_TYPE_REMOVE_EMBEDDED_COMMENT';
export const MSG_TYPE_TOGGLE_EMBEDDED_COMMENTS = 'MSG_TYPE_TOGGLE_EMBEDDED_COMMENTS';
export const MSG_TYPE_COMMENTS_UPDATED = 'MSG_TYPE_COMMENTS_UPDATED';
export const MSG_TYPE_COMMENTS_BROADCAST = 'MSG_TYPE_COMMENTS_BROADCAST';
export const MSG_TYPE_UPDATE_COMMENT_META_DESCRIPTION = 'MSG_TYPE_UPDATE_COMMENT_META_DESCRIPTION';
export const MSG_MARK_COMMENT_AS_READ_BROADCAST = 'MSG_MARK_COMMENT_AS_READ_BROADCAST';
export const MSG_TYPE_RESOLVE_COMMENT_SUCCESS = 'MSG_TYPE_RESOLVE_COMMENT_SUCCESS';
export const MSG_TYPE_UNRESOLVE_COMMENT_SUCCESS = 'MSG_TYPE_UNRESOLVE_COMMENT_SUCCESS';
export const MSG_TYPE_UNDO_RESOLVE_COMMENT = 'MSG_TYPE_UNDO_RESOLVE_COMMENT';
export const MSG_TYPE_EVICT_UNREAD_REPLIES_AND_UNREAD_COUNT = 'MSG_TYPE_EVICT_UNREAD_REPLIES_AND_UNREAD_COUNT';
export const MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL = 'MSG_TYPE_OPEN_NOTIFICATION_SETTINGS_MODAL';
export const MSG_TYPE_NOTIFICATION_SETTINGS_LOADING = 'MSG_TYPE_NOTIFICATION_SETTINGS_LOADING';
export const MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE = 'MSG_TYPE_NOTIFICATION_SETTINGS_FAILURE';
export const MSG_TYPE_NOTIFICATION_SETTINGS_SUCCESS = 'MSG_TYPE_NOTIFICATION_SETTINGS_SUCCESS';
export const MSG_TYPE_SAVE_NOTIFICATION_SETTINGS = 'MSG_TYPE_SAVE_NOTIFICATION_SETTINGS';

// Task create consts
export const MSG_TYPE_CREATE_TASK_SUCCESS = 'MSG_TYPE_CREATE_TASK_SUCCESS';
export const MSG_TYPE_CREATE_TASK_FAILURE = 'MSG_TYPE_CREATE_TASK_FAILURE';

// Task update consts
export const MSG_TYPE_UPDATE_TASK_SUCCESS = 'MSG_TYPE_UPDATE_TASK_SUCCESS';
export const MSG_TYPE_UPDATE_TASK_FAILURE = 'MSG_TYPE_UPDATE_TASK_FAILURE';

// Task delete consts
export const MSG_TYPE_DELETE_TASK = 'MSG_TYPE_DELETE_TASK';
export const MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL = 'MSG_TYPE_REQUEST_OPEN_DELETE_TASK_MODAL';
export const MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL = 'MSG_TYPE_REQUEST_CLOSE_DELETE_TASK_MODAL';
export const MSG_TYPE_CONFIRM_DELETE_TASK = 'MSG_TYPE_CONFIRM_DELETE_TASK';
export const MSG_TYPE_DELETE_TASK_SUCCESS = 'MSG_TYPE_DELETE_TASK_SUCCESS';
export const MSG_TYPE_DELETE_TASK_FAILURE = 'MSG_TYPE_DELETE_TASK_FAILURE';

// Commentable area
export const MSG_TYPE_REMOVE_COMMENT_ON_MODULE = 'MSG_TYPE_REMOVE_COMMENT_ON_MODULE';

// Breeze
export const MSG_TYPE_INVOKE_BREEZE_SKILL = 'MSG_TYPE_INVOKE_BREEZE_SKILL';